import { useState } from "react";
import { Send, Loader2, Check } from "lucide-react";
import { toast } from "sonner";

const sameDay = (iso) => iso && Date.now() - new Date(iso).getTime() < 20 * 3600 * 1000;

export default function NudgeButton({ c, api, onSent, tid = `nudge-${c.user_id}` }) {
  const [busy, setBusy] = useState(false);
  if (c.pct >= 50) return null;
  const sent = sameDay(c.last_reminded_at);
  const send = async () => {
    setBusy(true);
    try {
      const missing = c.parts.flatMap((p) => p.missing).slice(0, 60);
      const { data } = await api.post(`/admin/customers/${c.user_id}/remind`, { missing, pct: c.pct });
      toast.success(`Reminder sent to ${c.email}`);
      onSent(c.user_id, data.last_reminded_at);
    } catch (e) {
      toast.error(e.response?.data?.detail || "Could not send the reminder.");
    } finally {
      setBusy(false);
    }
  };
  if (!c.email) return <span className="text-[11px] text-muted-foreground">No email</span>;
  return (
    <button onClick={send} disabled={busy || sent} data-testid={tid}
      title={sent ? `Reminder sent ${new Date(c.last_reminded_at).toLocaleString()}` : `Email ${c.email} their missing items`}
      className="min-h-[36px] px-2.5 border border-[#262626] hover:border-[#FFD600] hover:text-[#FFD600] disabled:opacity-60 disabled:hover:border-[#262626] disabled:hover:text-inherit font-mono-label text-[10px] inline-flex items-center gap-1.5 whitespace-nowrap transition-colors">
      {busy ? <Loader2 size={12} className="animate-spin" /> : sent ? <Check size={12} className="text-[#16A34A]" /> : <Send size={12} />}
      {sent ? "Reminded" : "Send reminder"}
    </button>
  );
}
